import { LitElement as u, html as m, render as p } from "lit";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const h = (e) => (t) => typeof t == "function" ? ((n, i) => (customElements.define(n, i), i))(e, t) : ((n, i) => {
  const { kind: r, elements: o } = i;
  return { kind: r, elements: o, finisher(a) {
    customElements.define(n, a);
  } };
})(e, t);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const y = (e, t) => t.kind === "method" && t.descriptor && !("value" in t.descriptor) ? { ...t, finisher(n) {
  n.createProperty(t.key, e);
} } : { kind: "field", key: Symbol(), placement: "own", descriptor: {}, originalKey: t.key, initializer() {
  typeof t.initializer == "function" && (this[t.key] = t.initializer.call(this));
}, finisher(n) {
  n.createProperty(t.key, e);
} };
function d(e) {
  return (t, n) => n !== void 0 ? ((i, r, o) => {
    r.constructor.createProperty(o, i);
  })(e, t, n) : y(e, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function f(e) {
  return d({ ...e, state: !0 });
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var c;
((c = window.HTMLSlotElement) === null || c === void 0 ? void 0 : c.prototype.assignedElements) != null;
var C = Object.defineProperty, v = Object.getOwnPropertyDescriptor, l = (e, t, n, i) => {
  for (var r = i > 1 ? void 0 : i ? v(t, n) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (r = (i ? a(t, n, r) : a(r)) || r);
  return i && r && C(t, n, r), r;
};
let s = class extends u {
  constructor() {
    super(...arguments), this.containerClass = "", this.body = m``, this.uniqueID = `lit-portal-${Math.random().toString(36).substring(2)}`;
  }
  // 2 - HELPERS
  // Returns the element to which the body should be "portal-ed"
  getOrCreateDestination() {
    let e = null;
    return typeof this.to != "string" || this.to === "" ? e = document.body : (e = document.getElementById(this.to), e || (e = document.createElement("div"), e.id = this.to, document.body.appendChild(e))), e;
  }
  // Returns the unique div inside the destination within which the body should be rendered
  getOrCreateContainer() {
    let e = document.getElementById(this.uniqueID);
    return e || (e = document.createElement("div"), e.id = this.uniqueID, e.className = this.containerClass, this.getOrCreateDestination().appendChild(e), e);
  }
  removeContainer() {
    var e;
    (e = document.getElementById(this.uniqueID)) == null || e.remove();
  }
  // 3 - LIFECYCLE METHODS
  // React to changes in to, containerClass and body
  updated(e) {
    e.has("to") && this.removeContainer(), p(this.body, this.getOrCreateContainer()), e.has("containerClass") && (this.getOrCreateContainer().className = this.containerClass);
  }
  // Remove the container when the element is unmounted
  disconnectedCallback() {
    this.removeContainer(), super.disconnectedCallback();
  }
  // Render function returns nothing since we don't want to render anything inline
  render() {
  }
};
l([
  d()
], s.prototype, "to", 2);
l([
  d()
], s.prototype, "containerClass", 2);
l([
  d()
], s.prototype, "body", 2);
l([
  f()
], s.prototype, "uniqueID", 2);
s = l([
  h("lit-portal")
], s);
export {
  s as LitPortal
};
